module.exports = __webpack_public_path__ + "static/img/Jahrome-Hughes.dd08b71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jahrome-Hughes.jpg
// module id = mHZX
// module chunks = 0